/** @format */

import React, { useEffect, useState } from 'react';
import './styles.scss';
// import {
//   // Table,
//   // Button,
//   // InputGroup
// } from 'react-bootstrap';
// import Form from 'react-bootstrap/Form';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {
//   // faXmarkCircle,
//   // faCircleCheck,
//   faSearch
//   // faCopy
// } from '@fortawesome/free-solid-svg-icons';
// import Pagination from '../Pagination';
import { useDispatch, useSelector } from 'react-redux';
import { listAllOwnerOnboardDataRequestedAction } from 'stateContainer/actions';
import moment from 'moment';
// import TableDataLoader from 'components/TableDataLoader';
// import ButtonSyncLoader from 'components/ButtonSyncLoader';
import appConfig from 'config/app';
import StatusIndicator from 'components/StatusIndicator';
// import { DataTable as Table } from 'components/DataTable';
import { DataTable as Table } from 'components/MaterialUiDataTable';
import { ExpandableTableRow as ExpandableRow } from './ExpandableTableRow';
import CustomSearch from './CustomSearch';
import { Button } from 'react-bootstrap';

// const recordsPerPage = ;

export default function NyamaklareOwnerOnboarding({
  // eslint-disable-next-line no-empty-pattern
  text: {
    // heading,
    // table: { table_headings }
  }
  // handleCopyLinkToClipBoard
}) {
  // eslint-disable-next-line no-unused-vars
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [leadsSearchText, setLeadsSearchText] = useState(null);
  // const [searchName, setSearchName] = useState('');
  const [onboardStatusType, setOnboardStatusType] = useState('registered');

  useEffect(() => {
    dispatch(
      listAllOwnerOnboardDataRequestedAction(onboardStatusType, {
        page: currentPage,
        recordsPerPage,
        search: leadsSearchText
      })
    );
  }, [recordsPerPage, currentPage, onboardStatusType]);

  const allOwnerOnboardData = useSelector((state) => state.ownerOnboardData);
  const paginationData = useSelector((state) => state.ownerOnboardData.paging);

  const dispatch = useDispatch();

  const formatDataRow = (dataRow) => {
    return {
      leadType: dataRow.leadType,
      email: dataRow.email,
      city: dataRow.city,
      name: dataRow.name,
      status: dataRow.status,
      createdDatetime: dataRow.createdDatetime
        ? moment(dataRow.createdDatetime).format(
            appConfig.defaultMomentDateTimeFormat
          )
        : '-'
    };
  };

  return (
    <div className='leads-container'>
      <div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: 10,
            height: '50px'
          }}>
          <Button
            className={`btn ${
              onboardStatusType === 'registered' ? 'btn-pink' : 'btn-white'
            }`}
            onClick={() => {
              setOnboardStatusType('registered');
            }}>
            Just Registered
          </Button>
          <Button
            className={`btn ${
              onboardStatusType === 'approved' ? 'btn-pink' : 'btn-white'
            }`}
            onClick={() => {
              setOnboardStatusType('approved');
            }}>
            Approved
          </Button>
          <Button
            className={`btn ${
              onboardStatusType === 'completed' ? 'btn-pink' : 'btn-white'
            }`}
            onClick={() => {
              setOnboardStatusType('completed');
            }}>
            Onboading Completed
          </Button>
        </div>
        <Table
          loading={allOwnerOnboardData.listRequesting}
          title='Nya Mäklare - Owner Onboarding'
          className='leads-table'
          columns={[
            // {
            //   label: 'Status',
            //   name: 'leadType',
            //   options: {
            //     customBodyRender: (value) => {
            //       return (
            //         <div className='lead-type-cell-body'>{value ?? '-'}</div>
            //       );
            //     }
            //   }
            // },
            {
              label: 'Name',
              name: 'name',
              options: {
                draggable: false
              }
            },
            {
              label: 'Email',
              name: 'email'
            },
            {
              label: 'City',
              name: 'city'
            },
            {
              label: 'Phone',
              name: 'phone'
            },
            {
              label: 'Status',
              name: 'status',
              options: {
                customBodyRender: (value) => {
                  return (
                    <StatusIndicator
                      greenStatus={value === 'active'}
                      greyStatus={value !== 'active'}
                      text={value.toUpperCase()}
                    />
                  );
                }
              }
            }
          ]}
          data={allOwnerOnboardData.data.map(formatDataRow)}
          options={{
            serverSide: true,
            draggableColumns: {
              enabled: true
            },
            enableNestedDataAccess: '.',
            expandableRows: true,
            expandableRowsHeader: false,
            expandableRowsOnClick: true,
            pagination: true,
            responsive: 'vertical',
            download: false,
            filter: false,
            print: false,
            renderExpandableRow: (rowData, rowMeta) => (
              <ExpandableRow rowData={rowData} rowMeta={rowMeta} />
            ),
            onChangeRowsPerPage: (numberOfRows) => {
              setRecordsPerPage(numberOfRows);
            },
            onChangePage: (page) => {
              setCurrentPage(page + 1);
            },
            count: paginationData?.totalRecords,
            rowsPerPageOptions: [10, 20, 50, 100],
            customSearchRender: (
              searchText,
              _handleSearch,
              hideSearch,
              currentSearch
            ) => (
              <CustomSearch
                searchText={searchText}
                onSearch={(text) => {
                  setLeadsSearchText(text);
                  dispatch(
                    listAllOwnerOnboardDataRequestedAction(onboardStatusType, {
                      search: text,
                      recordsPerPage
                    })
                  );
                }}
                hideSearch={hideSearch}
                currentSearch={currentSearch}
              />
            )
          }}
        />
      </div>
    </div>
  );
}
